import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import {
  getAccountFundTransfers,
  getAccountFundTransfer,
  createAccountFundTransfer,
  updateAccountFundTransfer,
  deleteAccountFundTransfer,
} from 'api/accountFundTransferApi'
import { ACCOUNT_QUERY_KEY } from 'hooks/useAccountEntity'
import { ACCOUNT_TRANSACTION_QUERY_KEY } from 'hooks/useAccountTransaction'
import { ACCOUNT_DASHBOARD_QUERY_KEY } from 'hooks/useAccountDashboard'

const invalidateRelatedQueries = (queryClient) => {
  queryClient.invalidateQueries({ queryKey: ['account-fund-transfers'] })
  queryClient.invalidateQueries({ queryKey: [ACCOUNT_QUERY_KEY] })
  queryClient.invalidateQueries({ queryKey: [ACCOUNT_TRANSACTION_QUERY_KEY] })
  queryClient.invalidateQueries({ queryKey: [ACCOUNT_DASHBOARD_QUERY_KEY] })
}

export const useAccountFundTransfers = (params = {}, enabled = true) => {
  return useQuery({
    queryKey: ['account-fund-transfers', params],
    queryFn: () => getAccountFundTransfers(params),
    enabled,
  })
}

export const useAccountFundTransfer = (id, enabled = true) => {
  return useQuery({
    queryKey: ['account-fund-transfers', id],
    queryFn: () => getAccountFundTransfer(id),
    enabled: enabled && !!id,
  })
}

export const useCreateAccountFundTransfer = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: createAccountFundTransfer,
    onSuccess: () => invalidateRelatedQueries(queryClient),
  })
}

export const useEditAccountFundTransfer = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ id, ...data }) => updateAccountFundTransfer(id, data),
    onSuccess: () => invalidateRelatedQueries(queryClient),
  })
}

export const useDeleteAccountFundTransfer = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: deleteAccountFundTransfer,
    onSuccess: () => invalidateRelatedQueries(queryClient),
  })
}
